// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"473b04d6","455":"f7343c12","977":"0c905e9c"}[chunkId] + ".chunk.js";
};